import React from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import logoBonna from "../assets/img/logobonna_w.png"
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router';
import { IoIosLogOut } from "react-icons/io";
import useAuthCall from '../hooks/useAuthCall';
import {
  isOdulOneriIkAuthorized,
  isOdulOneriOpexAuthorized,
  canAccessReport,
} from '../helper/authorizedUsers';
import { REPORT_KEYS } from '../helper/accessControlConstants';

const reporPages = [
  {
    title: "Teşekkür",
    url: '/report/tesekkur',
    reportKey: REPORT_KEYS.TESEKKUR,
  },
  {
    title: "Talep",
    url: '/report/oneritalep',
    reportKey: REPORT_KEYS.ONERITALEP,
  },
  {
    title: "Şikayet",
    url: '/report/sikayet',
    reportKey: REPORT_KEYS.SIKAYET,
  },
  {
    title: "Tehlikeli Durum & Ramak Kala",
    url: '/report/ramakkala',
    reportKey: REPORT_KEYS.RAMAKKALA,
  },
  {
    title: "Etik",
    url: '/report/etiklik',
    reportKey: REPORT_KEYS.ETIKLIK,
  }
];

const odulOneriTakipPage = {
  title: 'Ödül Öneri Rapor',
  url: '/odul-oneri/ik-takip',
}

const odulOneriConfigPage = {
  title: 'Öneri Süreci Ayarları',
  url: '/odul-oneri/ik-config',
}


const odulOpexTakipPage = {
  title: 'Uygulama Takip',
  url: '/odul-oneri/opex-takip',
}

const odulOpexKurulPage = {
  title: 'Kurul Toplantısı',
  url: '/odul-oneri/kurul-toplanti',
}

const NavBar = () => {
  const { logout } = useAuthCall()
  const { currentUser } = useSelector((state) => state.auth)
  const permissions = useSelector((state) => state.accessControl.permissions)
  const navigate = useNavigate()

  const emailKey = String(currentUser || '').toLowerCase()
  const userReports = permissions[emailKey]?.reports
  const can = (key) =>
    userReports ? Boolean(userReports[key]) : canAccessReport(currentUser, key)

  const isOdulOneriIkUser = can(REPORT_KEYS.ODUL_IK) || isOdulOneriIkAuthorized(currentUser)
  const isOdulOneriOpexUser =
    can(REPORT_KEYS.ODUL_OPEX) || isOdulOneriOpexAuthorized(currentUser)

  // Rapor menüsü — kullanıcıya açık rapor bayrakları
  let filteredReporPages = currentUser
    ? reporPages.filter((page) => can(page.reportKey))
    : []

  if (isOdulOneriIkUser) {
    filteredReporPages = [...filteredReporPages, odulOneriTakipPage]
  }

  const odulOneriMenuPages = []
  if (isOdulOneriOpexUser) {
    odulOneriMenuPages.push(odulOpexTakipPage, odulOpexKurulPage)
  }
  if (isOdulOneriIkUser) {
    odulOneriMenuPages.push(odulOneriConfigPage)
  }
  const showOdulOneriMenu = odulOneriMenuPages.length > 0

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElRapor, setAnchorElRapor] = React.useState(null);
  const [anchorElOdul, setAnchorElOdul] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const openRapor = Boolean(anchorElRapor);
  const handleOpenRapor = (event) => {
    setAnchorElRapor(event.currentTarget);
  };
  const handleCloseRapor = () => {
    setAnchorElRapor(null);
  };

  const openOdul = Boolean(anchorElOdul);
  const handleOpenOdul = (event) => {
    setAnchorElOdul(event.currentTarget);
  };
  const handleCloseOdul = () => {
    setAnchorElOdul(null);
  };

  return (
    <AppBar sx={{ backgroundColor: '#1F2937' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between' }}>

          <Box sx={{ display: { xs: 'flex', md: 'flex' }, mr: 5 }} >
            <img
              src={logoBonna}
              alt="bonnaLogo"
              width='130px'
            />
          </Box>

          {/* Mobile menu */}
          {currentUser && (
            <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                <Button
                  onClick={() => {
                    navigate('/')
                    handleCloseNavMenu()
                  }}
                  sx={{ width: '100%', textTransform: 'none' }}
                >
                  Ana Sayfa
                </Button>

                <Typography sx={{ px: 2, pt: 1, fontSize: 12, fontWeight: 700, color: 'text.secondary' }}>
                  Rapor
                </Typography>
                {filteredReporPages.map((page, index) => (
                  <Button
                    key={`rapor-m-${index}`}
                    sx={{ width: '100%', textTransform: 'none', color: 'black', justifyContent: 'flex-start', pl: 3 }}
                    onClick={() => {
                      navigate(page.url)
                      handleCloseNavMenu()
                    }}
                  >
                    {page.title}
                  </Button>
                ))}

                {showOdulOneriMenu && (
                  <>
                    <Typography sx={{ px: 2, pt: 1, fontSize: 12, fontWeight: 700, color: 'text.secondary' }}>
                      Ödül Öneri
                    </Typography>
                    {odulOneriMenuPages.map((page, index) => (
                      <Button
                        key={`odul-m-${index}`}
                        sx={{ width: '100%', textTransform: 'none', color: 'black', justifyContent: 'flex-start', pl: 3 }}
                        onClick={() => {
                          navigate(page.url)
                          handleCloseNavMenu()
                        }}
                      >
                        {page.title}
                      </Button>
                    ))}
                  </>
                )}

                <Button
                  onClick={() => logout()}
                  sx={{ width: '100%', textTransform: 'none', color: 'red' }}
                >
                  Çıkış
                </Button>
              </Menu>
            </Box>
          )}

          {/* Desktop menu */}
          {currentUser && (
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
                <Button
                  onClick={() => navigate('/')}
                  sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none' }}
                >
                  Ana Sayfa
                </Button>

                <Button
                  sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none' }}
                  id="rapor-menu-button"
                  aria-controls={openRapor ? 'rapor-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openRapor ? 'true' : undefined}
                  onClick={handleOpenRapor}
                >
                  Rapor
                </Button>
                <Menu
                  id="rapor-menu"
                  MenuListProps={{ 'aria-labelledby': 'rapor-menu-button' }}
                  anchorEl={anchorElRapor}
                  open={openRapor}
                  onClose={handleCloseRapor}
                >
                  {filteredReporPages.map((item, index) => (
                    <MenuItem
                      key={`rapor-d-${index}`}
                      onClick={() => {
                        navigate(item.url)
                        handleCloseRapor()
                      }}
                    >
                      {item.title}
                    </MenuItem>
                  ))}
                </Menu>

                {showOdulOneriMenu && (
                  <>
                    <Button
                      sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none' }}
                      id="odul-menu-button"
                      aria-controls={openOdul ? 'odul-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openOdul ? 'true' : undefined}
                      onClick={handleOpenOdul}
                    >
                      Ödül Öneri
                    </Button>
                    <Menu
                      id="odul-menu"
                      MenuListProps={{ 'aria-labelledby': 'odul-menu-button' }}
                      anchorEl={anchorElOdul}
                      open={openOdul}
                      onClose={handleCloseOdul}
                    >
                      {odulOneriMenuPages.map((item, index) => (
                        <MenuItem
                          key={`odul-d-${index}`}
                          onClick={() => {
                            navigate(item.url)
                            handleCloseOdul()
                          }}
                        >
                          {item.title}
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                )}
              </Box>
            </Box>
          )}

          {currentUser ? (
            <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', gap: 3, mr: 1 }}>
              <Typography>{currentUser}</Typography>
              <IoIosLogOut size={25} color='#B31312' cursor='pointer' onClick={() => logout()} />
            </Box>
          ) : (
            ""
          )}

        </Toolbar>
      </Container>

      <Box>
        <Outlet />
      </Box>
    </AppBar>
  )
}

export default NavBar
